const d3 = require("d3");
const { MilestoneVisual } = require("@/visualisation/gantt/milestoneVisual.js");
const { TaskVisuals } = require("@/visualisation/gantt/taskVisuals.js");
const { getTranslation } = require("./../visualHelperFunctions.js")

class ProjectVisual {
    constructor(visualiser, project, projectIndex) {
        this.visualiser = visualiser;
        this.project = project;
        this.projectIndex = projectIndex;
        this.parentGroup = this.visualiser.projectsSubGroup.append('g').attr('class', 'parentGroup');
        this.projectRowCount = this.getProjectRowCount();

        this.taskLocations = this.getTaskLocations();
        this.updateCulling();
    }

    createProjectElements() {
        this.projectGroup = this.parentGroup
            .selectAll("projectGroup")
            .data([this.project])
            .enter()
            .append('g')
            .attr('class', 'projectGroup')

        //Get the locations of the task and milestones within the project
        this.milestoneVisual = new MilestoneVisual(this.visualiser, this);

        //Create the actual elements
        this.createTaskElements();

        //Set te Y level for the projects, also used for sorting

        var currYLevel = this.getProjectGroupYLocation(false);

        this.parentGroup.attr("transform", `translate(${0}, ${currYLevel})`);

        //To ensure that the today line is above the projects
        this.visualiser.miscVisuals.createTodayLineElements();
    }

    //Get the YVal of the neighbouring projectVisuals
    getNeighbouringProjectYVals() {
        var prevYLevel = null;
        var nextYLevel = null;

        //Get the previous project
        var prevProject = this.visualiser.projectVisuals[this.projectIndex - 1];
        if (prevProject) {
            prevYLevel = (prevProject.getProjectGroupYLocation(false) + prevProject.getProjectGroupYLocation(true)) / 2;
        }
        
        //Get the next project
        var nextProject = this.visualiser.projectVisuals[this.projectIndex + 1];
        if (nextProject) {
            nextYLevel = (nextProject.getProjectGroupYLocation(false) + nextProject.getProjectGroupYLocation(true)) / 2 - 25;
        }

        return [prevYLevel, nextYLevel];
    }

    swapProjects(up){
        var index = this.visualiser.getProjectVisualIndex(this);

        if(up && index == 0){
            return;
        }

        if(!up && index == this.visualiser.projectVisuals.length - 1){
            return;
        }

        var otherIndex = index - 1;
        if(!up){
            otherIndex = index + 1;
        }
        
        var otherProjectVisual = this.visualiser.projectVisuals[otherIndex];

        //Swap the project visuals
        this.visualiser.projectVisuals[index] = otherProjectVisual;
        this.visualiser.projectVisuals[otherIndex] = this;
        this.visualiser.sortProjects(true, 1);
    }

    moveProjectElementsToX(x){
 
        this.parentGroup.attr("transform", `translate(${x}, ${0})`);

    }

    //Calculates the Y value for the project groups
    getProjectGroupYLocation(getNext) {
        var params = this.visualiser.params;
        if (getNext) {
            return (params.taskYSize + params.taskYSpacing) * (this.projectRowCount + this.project.maxRowAmount) + params.betweenProjectsSpacing * (this.projectIndex + 1);
        }
        else {
            return (params.taskYSize + params.taskYSpacing) * (this.projectRowCount) + params.betweenProjectsSpacing * this.projectIndex;
        }
    }

    createTaskElements() {
        this.taskVisuals = new TaskVisuals(this.visualiser, this, this.taskLocations);
    }

    updateProjectRowCount() {
        this.projectRowCount = this.getProjectRowCount();
    }

    getProjectRowCount() {
        var projectRowCount = 0;
        var index = 0;

        this.visualiser.projectVisuals.forEach(currProjectVisual => {
            if (index == this.projectIndex || currProjectVisual.project.isFinished()) {
                return;
            }
            projectRowCount += currProjectVisual.project.maxRowAmount;
            index++;
        })

        // this.visualiser.simulator.projectPool.projects.forEach((currProject) => {
        //     if (index < this.projectIndex && !currProject.isFinished()) {
        //         index += 1;
        //         projectRowCount += currProject.maxRowAmount;
        //     }
        // })

        return projectRowCount;
    }

    //Get the X and Y locations for each task
    getTaskLocations() {
        var plannedXStartDict = {};
        var plannedXEndDict = {};

        this.project.taskArray.forEach(currTask => {
            plannedXStartDict[currTask.taskName] = currTask.startHour;
            plannedXEndDict[currTask.taskName] = currTask.startHour + currTask.totalWorkHours;
        });

        var yValDict = this.getAllTaskYLocations();

        return this.combineTasksLocations(plannedXStartDict, plannedXEndDict, yValDict);
    }

    // Gets all the Y locations by using the rows and spacing
    getAllTaskYLocations() {
        var yValDict = {};
        var params = this.visualiser.params;

        this.project.taskArray.forEach(currTask => {
            yValDict[currTask.taskName] = currTask.row * (params.taskYSize + params.taskYSpacing) + (params.taskYSize + params.taskYSpacing);
        })

        this.y = (params.taskYSize + params.taskYSpacing)
        return yValDict;
    }

    // Combine the locations and colours for d3
    combineTasksLocations(plannedXStartDict, plannedXEndDict, yValDict) {
        var taskLocations = [];
        var params = this.visualiser.params;

        //Get all the task locations for the current project
        this.project.taskArray.forEach(currTask => {
            var currName = currTask.taskName;
            var currLocations = {}

            //Calculate the locations
            currLocations.x1 = plannedXStartDict[currName] * params.xScaling + params.paddingLeft;
            currLocations.x2 = plannedXEndDict[currName] * params.xScaling + params.paddingLeft;
            currLocations.y1 = yValDict[currName] + params.paddingTop;
            currLocations.y2 = yValDict[currName] + params.taskYSize + params.paddingTop;

            //Store the task for easy access
            currLocations.task = currTask;
            taskLocations.push(currLocations);
        })

        return taskLocations;
    }

    checkIfRender() {
        if (!this.visualiser.params.useCulling) {
            return true;
        }


        if (this.project.isFinished()) {
            return false;
        }

        var currTopY = this.getProjectGroupYLocation(false);
        var currBottomY = this.getProjectGroupYLocation(true);
        

        if (currTopY > this.visualiser.svgBottom + 100) {
            return false;
        }

        if (currBottomY < this.visualiser.svgTop - 100) {
            return false;
        }
        return true;
    }

    updateCulling() {

        var isRendered = this.projectGroup != null;
        var shouldRender = this.checkIfRender();


        if (this.project.isFinished() && this.project.getMinimumEndHour() <= this.visualiser.simulator.hoursPassed) {
            return;
        }

        if (isRendered == shouldRender) {
            return;
        }

        if (isRendered && this.visualiser.params.useCulling) {
            this.projectGroup.remove();
            this.milestoneVisual.milestoneGroup.remove();
            this.projectGroup = null;
        }
        else {
            this.createProjectElements();
        }


    }


    updateElements(duration, forceUpdate) {
        if (this.projectGroup == null) {
            return;
        }
        if (this.projectGroup != null && this.project.isFinished() && this.project.getMinimumEndHour() <= this.visualiser.simulator.hoursPassed) {
            this.projectGroup.remove();
            this.milestoneVisual.milestoneGroup.remove();

            this.projectGroup = null;
            return;
        }

        this.milestoneVisual.updateElements(duration);
        this.taskVisuals.updateElements(duration);
    }
}

module.exports = { ProjectVisual };
